import { render, staticRenderFns } from "./Recover.vue?vue&type=template&id=16d7d8bc"
import script from "./Recover.vue?vue&type=script&lang=js"
export * from "./Recover.vue?vue&type=script&lang=js"
import style0 from "@/components/base/estilos-login.scss?vue&type=style&index=0&prod&lang=scss&external"
import style1 from "./Recover.vue?vue&type=style&index=1&id=16d7d8bc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports